import colors from "app/colors";
import { TagFragment } from "gql/graphql";
import { highlightText } from "./quill-highlight-text";

export const renderQuillTagMention = (tag: TagFragment, searchTerm: string) => {
  const color = colors.blue;
  const callout = `${tag.displayName}`;

  const wrapper = document.createElement("div");
  wrapper.style.display = "flex";
  wrapper.style.alignItems = "center";
  // wrapper.style.gap = "8px";

  const icon = document.createElement("div");
  icon.innerHTML = `
    <svg width="16px" height="16px" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.3334 6.6665V5.33317H10.6667V2.6665H9.33335V5.33317H6.66669V2.6665H5.33335V5.33317H2.66669V6.6665H5.33335V9.33317H2.66669V10.6665H5.33335V13.3332H6.66669V10.6665H9.33335V13.3332H10.6667V10.6665H13.3334V9.33317H10.6667V6.6665H13.3334ZM9.33335 9.33317H6.66669V6.6665H9.33335V9.33317Z" fill=${colors.blue} />
    </svg>
  `;
  icon.style.flexShrink = "0";
  icon.style.display = "flex";
  icon.style.alignItems = "center";

  wrapper.appendChild(icon);

  const textElement = highlightText(callout, searchTerm);
  textElement.style.fontStyle = tag.active ? "normal" : "italic";
  textElement.style.color = color;
  textElement.style.fontWeight = "500";
  textElement.style.fontSize = "14px";
  textElement.style.opacity = tag.active ? "1" : "0.6";

  wrapper.appendChild(textElement);

  return wrapper;
};
